import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeHTML',
})
export class SafeHTMLPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url) {
    // return this.sanitizer.sanitize(SecurityContext.URL, url);
    const sanitized = this.sanitizer.bypassSecurityTrustHtml(url);
    return sanitized;
  }
}
